import React from 'react';

export default ({ children }) => (
	<div className='Main'>
		<div className='Main_body'>
			{ children }
		</div>
	</div>
);